import * as Models from "@gigalot/data-models"
import { AnimalListItem } from "@/models/animal-list-item"

let isBusy: boolean = true;

let animalListItems: AnimalListItem[] = [];
let animalListItemIndexBySgtin = new Map<string, number>();

let promises: { resolve: any, reject: any }[] = [];

function resolve() {
  for (const p of promises) {
    p.resolve(animalListItems);
  }
}

function animalToListItem(a: Models.Animal & { visualSgtin?: string }): AnimalListItem {
  return {
    breed: a.breed,
    gender: a.gender,
    sgtin: a.sgtin,
    customFeeder: a.customFeeder,
    visualSgtin: a.visualSgtin,
  };
}

export async function initialize(store: any) {
  isBusy = true;
  animalListItems = await store.dispatch("dataManager/mapOverAnimals", (a: Models.Animal & { visualSgtin?: string }) => animalToListItem(a));
  animalListItemIndexBySgtin = new Map();
  for (let i = 0; i < animalListItems.length; i++) {
    const sgtin = animalListItems[i].sgtin;
    if (sgtin) animalListItemIndexBySgtin.set(sgtin, i);
  }
  resolve();
  isBusy = false;
}

export function getAnimalListItems() {
  if (!isBusy) return animalListItems;
  else {
    return new Promise<AnimalListItem[]>((resolve, reject) => {
      promises.push({ resolve, reject })
    })
  }
}

export function clearAnimalListItems() {
  animalListItems = [];
  animalListItemIndexBySgtin.clear();
}

export function addAnimalsAsTheyDownload(i: Models.Animal | Models.Animal[], isFreshDownload: boolean = false) {
  //console.log("addAnimalsAsTheyDownload, i:", JSON.stringify(i));
  isBusy = true;

  if (!Array.isArray(i)) i = [i];
  for (const a of i) {
    if (a === undefined) {
      console.warn("WARNING!!! addAnimalsAsTheyDownload given undefined animal, skipping...");
      continue;
    }

    const listItem = animalToListItem(a);

    if (!isFreshDownload) { //skip this step if download is a fresh download
      const index = animalListItemIndexBySgtin.get(a.sgtin);
      if (index !== undefined) {
        animalListItems[index] = listItem;
        continue;
      }
    }

    animalListItems.push(listItem);
    animalListItemIndexBySgtin.set(a.sgtin, animalListItems.length - 1);
  }

  isBusy = false;
}

export function removeAnimal(sgtin: string) {
  let index = animalListItemIndexBySgtin.get(sgtin)
  if (index === undefined) return;
  animalListItems.splice(index, 1);
  animalListItemIndexBySgtin.delete(sgtin);
  for (let i = index; i < animalListItems.length; i++) {
    if (animalListItems[i].sgtin) {
      animalListItemIndexBySgtin.set(animalListItems[i].sgtin as string, i);
    }
  }
}
